import React from 'react';

import { AccountsListContainer } from './styles';

interface AccountsListProps {
    isLinked?: boolean;
    isHoverable?: boolean;
    onAccountClick?: React.MouseEventHandler<HTMLDivElement>;
    children?: React.ReactNode;
}

export const AccountsList: React.FC<AccountsListProps> = (props) => {
    return (
        <AccountsListContainer isLinked={props.isLinked} isHoverable={props.isHoverable} onClick={props.onAccountClick}>
            {props.children}
        </AccountsListContainer>
    );
};
